/* eslint-disable */
import { Offer, OfferStatus } from '../models/offer.model';

export const mockOffer: Offer = {
  offerReference: '205b8cb4-7169-4dec-95e7-f344f26bf6e7',
  offer_status: OfferStatus.AVAILABLE,
  expected_delivery_date: {},
  number_of_replacements: 12,
  number_of_upgrades: 13,
  upsell_flag: true,
  upsell_reason: 'MULTIPLAN,BANK,RP_GOLD',
  rrp_flag: false,
  outstanding_dd_amount: 0,
  outstanding_dd_count: 12,
};
